// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mienfoo: PokeData = {
  "id": 619,
  "name": "mienfoo",
  "height": 9,
  "weight": 200,
  "base_experience": 70,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "jump-kick",
    "meditate",
    "swift",
    "high-jump-kick",
    "fury-swipes",
    "reversal",
    "detect",
    "fake-out",
    "bounce",
    "calm-mind",
    "u-turn",
    "force-palm",
    "aura-sphere",
    "drain-punch",
    "hone-claws",
    "quick-guard"
  ],
  "moves": [
    "jump-kick",
    "calm-mind",
    "drain-punch",
    "double-kick",
    "superpower",
    "bulk-up",
    "meteor-assault",
    "rolling-kick",
    "karate-chop",
    "coaching",
    "close-combat",
    "vacuum-wave"
  ],
  "evolution_chain": {
    "id": 314,
    "item": null,
    "species": [
      {
        "name": "mienfoo",
        "order": 620,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "mienshao",
        "order": 621,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 619,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 50,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47.5,
    "speed": 65,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
